/**
 * @fileoverview MessageConst const<br>
 * 本ファイルは定義書より出力されるため直接編集禁止<br>
 * 変更がある場合は定義書を変更しファイルを生成してください。
 */
'use strict';
const MessageConst = {
  COMMON: {
    /**
     * LogiPull - ロジプル -
     * @name LOGIPULL
     * @constant
     * @memberOf const.MessageConst
     */
    LOGIPULL: 'LogiPull - ロジプル -',

    /**
     * マイページ
     * @name MYPAGE
     * @constant
     * @memberOf const.MessageConst
     */
    MYPAGE: 'マイページ',

    /**
     * ログアウト
     * @name LOGOUT
     * @constant
     * @memberOf const.MessageConst
     */
    LOGOUT: 'ログアウト',

    /**
     * 履歴
     * @name HISTORY
     * @constant
     * @memberOf const.MessageConst
     */
    HISTORY: '履歴',

    /**
     * 実績
     * @name PERFORMANCE
     * @constant
     * @memberOf const.MessageConst
     */
    PERFORMANCE: '実績',

    /**
     * 入構一覧
     * @name ENTRY_LIST
     * @constant
     * @memberOf const.MessageConst
     */
    ENTRY_LIST: '入構一覧',

    /**
     * 車両管理
     * @name CARMANAGEMENT
     * @constant
     * @memberOf const.MessageConst
     */
    CARMANAGEMENT: '車両管理',

    /**
     * 管理
     * @name MANAGEMENT
     * @constant
     * @memberOf const.MessageConst
     */
    MANAGEMENT: '管理',

    /**
     * 集計
     * @name TOTAL
     * @constant
     * @memberOf const.MessageConst
     */
    TOTAL: '集計',

    /**
     * © 2020 Computer Engineering & Consulting, Ltd.
     * @name COPYRIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    COPYRIGHT: '© 2020 Computer Engineering & Consulting, Ltd.',

    /**
     * OK
     * @name OK
     * @constant
     * @memberOf const.MessageConst
     */
    OK: 'OK',

    /**
     * キャンセル
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    CANCEL: 'キャンセル',

    /**
     * ja<br>
     * ローカライズ文字列
     * @name JA
     * @constant
     * @memberOf const.MessageConst
     */
    JA: 'ja',

    /**
     * yyyy/mm/dd HH:mm<br>
     * moment.js 年月日時分
     * @name YYYYMMDD_HHMM
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMMDD_HHMM: 'yyyy/mm/dd HH:mm',

    /**
     * YYYY/MM/DD<br>
     * moment.js 年月日
     * @name YYYYMMDD
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMMDD: 'YYYY/MM/DD',

    /**
     * mm月<br>
     * moment.js 月
     * @name MM
     * @constant
     * @memberOf const.MessageConst
     */
    MM: 'mm月',

    /**
     * yyyy<br>
     * moment.js 年
     * @name YYYY
     * @constant
     * @memberOf const.MessageConst
     */
    YYYY: 'yyyy',

    /**
     * HH:mm<br>
     * moment.js 時分
     * @name HHMM
     * @constant
     * @memberOf const.MessageConst
     */
    HHMM: 'HH:mm',

    /**
     * YYYY年MM月DD日(ddd)<br>
     * mobiscroll dataFormat
     * @name YYYYMMDD_JP
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMMDD_JP: 'YYYY年MM月DD日(ddd)',

    /**
     * yy/mm/dd<br>
     * mobiscroll dataFormat
     * @name YYMMDD
     * @constant
     * @memberOf const.MessageConst
     */
    YYMMDD: 'yy/mm/dd',

    /**
     * YYYY/MM/DD HH:mm:ss<br>
     * mobiscroll dataFormat
     * @name YYYYMMDD_HHMMSS
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMMDD_HHMMSS: 'YYYY/MM/DD HH:mm:ss',

    /**
     * YYYY年MM月DD日<br>
     * mobiscroll dataFormat
     * @name YYYYMMDD_JP2
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMMDD_JP2: 'YYYY年MM月DD日',

    /**
     * YYYYMM<br>
     * mobiscroll dataFormat
     * @name YYYYMM
     * @constant
     * @memberOf const.MessageConst
     */
    YYYYMM: 'YYYYMM',

    /**
     * 日曜日
     * @name SUNDAY
     * @constant
     * @memberOf const.MessageConst
     */
    SUNDAY: '日曜日',

    /**
     * 月曜日
     * @name MONDAY
     * @constant
     * @memberOf const.MessageConst
     */
    MONDAY: '月曜日',

    /**
     * 火曜日
     * @name TUESDAY
     * @constant
     * @memberOf const.MessageConst
     */
    TUESDAY: '火曜日',

    /**
     * 水曜日
     * @name WEDNESDAY
     * @constant
     * @memberOf const.MessageConst
     */
    WEDNESDAY: '水曜日',

    /**
     * 木曜日
     * @name THURSDAY
     * @constant
     * @memberOf const.MessageConst
     */
    THURSDAY: '木曜日',

    /**
     * 金曜日
     * @name FRIDAY
     * @constant
     * @memberOf const.MessageConst
     */
    FRIDAY: '金曜日',

    /**
     * 土曜日
     * @name SATURDAY
     * @constant
     * @memberOf const.MessageConst
     */
    SATURDAY: '土曜日',

    /**
     * 日
     * @name SUNDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    SUNDAY_SH: '日',

    /**
     * 月
     * @name MONDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    MONDAY_SH: '月',

    /**
     * 火
     * @name TUESDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    TUESDAY_SH: '火',

    /**
     * 水
     * @name WEDNESDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    WEDNESDAY_SH: '水',

    /**
     * 木
     * @name THURSDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    THURSDAY_SH: '木',

    /**
     * 金
     * @name FRIDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    FRIDAY_SH: '金',

    /**
     * 土
     * @name SATURDAY_SH
     * @constant
     * @memberOf const.MessageConst
     */
    SATURDAY_SH: '土',

    /**
     * ：
     * @name COLON
     * @constant
     * @memberOf const.MessageConst
     */
    COLON: '：',

    /**
     * -
     * @name HYPHEN
     * @constant
     * @memberOf const.MessageConst
     */
    HYPHEN: '-',

    /**
     * ～
     * @name TILDE
     * @constant
     * @memberOf const.MessageConst
     */
    TILDE: '～',

    /**
     * ※
     * @name KOMEJIRUSHI
     * @constant
     * @memberOf const.MessageConst
     */
    KOMEJIRUSHI: '※',

    /**
     * ・
     * @name CHUTEN
     * @constant
     * @memberOf const.MessageConst
     */
    CHUTEN: '・',

    /**
     * /
     * @name SLASH
     * @constant
     * @memberOf const.MessageConst
     */
    SLASH: '/',

    /**
     * =
     * @name EQUAL
     * @constant
     * @memberOf const.MessageConst
     */
    EQUAL: '=',

    /**
     * @
     * @name AT
     * @constant
     * @memberOf const.MessageConst
     */
    AT: '@',

    /**
     * 必須
     * @name REQUIRED
     * @constant
     * @memberOf const.MessageConst
     */
    REQUIRED: '必須',

    /**
     * 検索結果件数
     * @name SEARCH_RESULT_COUNT
     * @constant
     * @memberOf const.MessageConst
     */
    SEARCH_RESULT_COUNT: '検索結果件数',

    /**
     * 件
     * @name COUNT
     * @constant
     * @memberOf const.MessageConst
     */
    COUNT: '件',

    /**
     * 選択した
     * @name SELECTED
     * @constant
     * @memberOf const.MessageConst
     */
    SELECTED: '選択した',

    /**
     * を削除
     * @name DELETE
     * @constant
     * @memberOf const.MessageConst
     */
    DELETE: 'を削除',

    /**
     * 「-」は入力しないでください。
     * @name MESSAGE_CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_CAR_NO: '「-」は入力しないでください。',

    /**
     * 車両
     * @name CAR
     * @constant
     * @memberOf const.MessageConst
     */
    CAR: '車両',

    /**
     * 車両番号
     * @name CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO: '車両番号',

    /**
     * 陸運支局
     * @name CAR_NO_AREA
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO_AREA: '陸運支局',

    /**
     * 分類番号
     * @name CAR_NO_TYPE
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO_TYPE: '分類番号',

    /**
     * 用途コード
     * @name CAR_NO_KANA
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO_KANA: '用途コード',

    /**
     * 一連番号
     * @name CAR_NO_NUMBER
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO_NUMBER: '一連番号',

    /**
     * 利用状態
     * @name AVAILABILITY
     * @constant
     * @memberOf const.MessageConst
     */
    AVAILABILITY: '利用状態',

    /**
     * 現場
     * @name WORKSPACE
     * @constant
     * @memberOf const.MessageConst
     */
    WORKSPACE: '現場',

    /**
     * 現場名
     * @name WORKSPACE_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    WORKSPACE_NAME: '現場名',

    /**
     * ステータス
     * @name STAY_STATUS
     * @constant
     * @memberOf const.MessageConst
     */
    STAY_STATUS: 'ステータス',

    /**
     * 業者名
     * @name COMPANY_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    COMPANY_NAME: '業者名',

    /**
     * 閉じる
     * @name CLOSE
     * @constant
     * @memberOf const.MessageConst
     */
    CLOSE: '閉じる',

    /**
     * ログイン画面に戻る
     * @name BACK_LOGIN_PAGE
     * @constant
     * @memberOf const.MessageConst
     */
    BACK_LOGIN_PAGE: 'ログイン画面に戻る',

    /**
     * メールアドレス
     * @name MAIL_ADDRESS
     * @constant
     * @memberOf const.MessageConst
     */
    MAIL_ADDRESS: 'メールアドレス',

    /**
     * 検索
     * @name SEARCH
     * @constant
     * @memberOf const.MessageConst
     */
    SEARCH: '検索',

    /**
     * 選択
     * @name SELECT
     * @constant
     * @memberOf const.MessageConst
     */
    SELECT: '選択',

    /**
     * 入場日時
     * @name ENTRY_DATE
     * @constant
     * @memberOf const.MessageConst
     */
    ENTRY_DATE: '入場日時',

    /**
     * 退場日時
     * @name EXIT_DATE
     * @constant
     * @memberOf const.MessageConst
     */
    EXIT_DATE: '退場日時',

    /**
     * 回転数
     * @name ROTATION_COUNT
     * @constant
     * @memberOf const.MessageConst
     */
    ROTATION_COUNT: '回転数',

    /**
     * 入場重量
     * @name ENTRY_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    ENTRY_WEIGHT: '入場重量',

    /**
     * 退場重量
     * @name EXIT_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    EXIT_WEIGHT: '退場重量',

    /**
     * 総重量
     * @name TOTAL_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    TOTAL_WEIGHT: '総重量',

    /**
     * 空車
     * @name EMPTY_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    EMPTY_WEIGHT: '空車',

    /**
     * 正味
     * @name NET_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    NET_WEIGHT: '正味重量',

    /**
     * 詳細
     * @name DETAIL
     * @constant
     * @memberOf const.MessageConst
     */
    DETAIL: '詳細',

    /**
     * 編集
     * @name EDIT
     * @constant
     * @memberOf const.MessageConst
     */
    EDIT: '編集',

    /**
     * 積込
     * @name LOADING
     * @constant
     * @memberOf const.MessageConst
     */
    LOADING: '積込',

    /**
     * 積降
     * @name UNLOADING
     * @constant
     * @memberOf const.MessageConst
     */
    UNLOADING: '積降',

    /**
     * kg
     * @name KG
     * @constant
     * @memberOf const.MessageConst
     */
    KG: 'kg',

    /**
     * 有効
     * @name VALID
     * @constant
     * @memberOf const.MessageConst
     */
    VALID: '有効',

    /**
     * 無効
     * @name INVALID
     * @constant
     * @memberOf const.MessageConst
     */
    INVALID: '無効',

    /**
     * 入荷
     * @name STOCK
     * @constant
     * @memberOf const.MessageConst
     */
    STOCK: '入荷',

    /**
     * 未入荷
     * @name NOTINSTOCK
     * @constant
     * @memberOf const.MessageConst
     */
    NOTINSTOCK: '未入荷',

    /**
     * 予定月
     * @name SCHEDULE_MONTH
     * @constant
     * @memberOf const.MessageConst
     */
    SCHEDULE_MONTH: '予定月',

    /**
     * 予定あり
     * @name HAS_SCHEDULE
     * @constant
     * @memberOf const.MessageConst
     */
    HAS_SCHEDULE: '予定あり',

    /**
     * 予定なし
     * @name HAS_NOT_SCHEDULE
     * @constant
     * @memberOf const.MessageConst
     */
    HAS_NOT_SCHEDULE: '予定なし',

    /**
     * 備考
     * @name NOTE
     * @constant
     * @memberOf const.MessageConst
     */
    NOTE: '備考',

    /**
     * WCN
     * @name WCN
     * @constant
     * @memberOf const.MessageConst
     */
    WCN: 'WCN',

    /**
     * ドライバー
     * @name DRIVER
     * @constant
     * @memberOf const.MessageConst
     */
    DRIVER: 'ドライバー',

    /**
     * 作業種別
     * @name WORK_KIND
     * @constant
     * @memberOf const.MessageConst
     */
    WORK_KIND: '作業種別',

    /**
     * 種類
     * @name TOTALCATEGORY
     * @constant
     * @memberOf const.MessageConst
     */
    TOTALCATEGORY: '種類',

    /**
     * 処理日
     * @name PROCESSDATE
     * @constant
     * @memberOf const.MessageConst
     */
    PROCESSDATE: '処理日',

    /**
     * マニュフェスト番号
     * @name MANIFEST_NO
     * @constant
     * @memberOf const.MessageConst
     */
    MANIFEST_NO: 'マニュフェスト番号',

    /**
     * 交付日
     * @name DATE_OF_ISSUE
     * @constant
     * @memberOf const.MessageConst
     */
    DATE_OF_ISSUE: '交付日',

    /**
     * 交付担当
     * @name STAFF_OF_ISSUE
     * @constant
     * @memberOf const.MessageConst
     */
    STAFF_OF_ISSUE: '交付担当',

    /**
     * 運搬担当
     * @name CARRIER_STAFF
     * @constant
     * @memberOf const.MessageConst
     */
    CARRIER_STAFF: '運搬担当',

    /**
     * 運転者/回数
     * @name MESUREMENTS
     * @constant
     * @memberOf const.MessageConst
     */
    MESUREMENTS: '運転者/回数',

    /**
     * 処理重量
     * @name PROCESS_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    PROCESS_WEIGHT: '処理重量',

    /**
     * (kg)
     * @name KG2
     * @constant
     * @memberOf const.MessageConst
     */
    KG2: '(kg)',

    /**
     * 種別
     * @name TYPE
     * @constant
     * @memberOf const.MessageConst
     */
    TYPE: '種別',

    /**
     * © 2024 Computer Engineering & Consulting, Ltd.
     * @name FOOTER
     * @constant
     * @memberOf const.MessageConst
     */
    FOOTER: '© 2024 Computer Engineering & Consulting, Ltd.',

    /**
     * ユーザーID
     * @name USER_ID
     * @constant
     * @memberOf const.MessageConst
     */
    USER_ID: 'ユーザーID',

    /**
     * パスワード
     * @name PASSWARD
     * @constant
     * @memberOf const.MessageConst
     */
    PASSWARD: 'パスワード',

    /**
     * 開始日
     * @name START_DATE
     * @constant
     * @memberOf const.MessageConst
     */
    START_DATE: '開始日',

    /**
     * 終了日
     * @name END_DATE
     * @constant
     * @memberOf const.MessageConst
     */
    END_DATE: '終了日',

    /**
     * 開始時刻
     * @name START_TIME
     * @constant
     * @memberOf const.MessageConst
     */
    START_TIME: '開始時刻',

    /**
     * 終了時刻
     * @name END_TIME
     * @constant
     * @memberOf const.MessageConst
     */
    END_TIME: '終了時刻',

    /**
     * 受注コード
     * @name ORDER_CODE
     * @constant
     * @memberOf const.MessageConst
     */
    ORDER_CODE: '受注コード',

    /**
     * 運搬事業者名
     * @name CARRIER_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    CARRIER_NAME: '運搬事業者名',

    /**
     * 排出事業者名
     * @name EMITTER_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    EMITTER_NAME: '排出事業者名',

    /**
     * 廃棄物名
     * @name PRODUCT_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    PRODUCT_NAME: '廃棄物名',

    /**
     * 発券番号
     * @name TICKET
     * @constant
     * @memberOf const.MessageConst
     */
    TICKET: '発券番号',

    /**
     * 品名
     * @name ITEM_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    ITEM_NAME: '品名',

    /**
     * 新規登録
     * @name NEW_REGEST
     * @constant
     * @memberOf const.MessageConst
     */
    NEW_REGEST: '新規登録',

    /**
     * 検索結果出力
     * @name OUTPUT_RESULT
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_RESULT: '検索結果出力',

    /**
     * クリア
     * @name SEARCH_CLEAR
     * @constant
     * @memberOf const.MessageConst
     */
    SEARCH_CLEAR: 'クリア',

    /**
     * 一括ソート50音順
     * @name ALL_ONEC_SORT
     * @constant
     * @memberOf const.MessageConst
     */
    ALL_ONEC_SORT: '一括ソート50音順',

    /**
     * xxxxx@xxx.co.jp
     * @name EXAMPLE_MAIL_ADDRESS
     * @constant
     * @memberOf const.MessageConst
     */
    EXAMPLE_MAIL_ADDRESS: 'xxxxx@xxx.co.jp',

    /**
     * 30文字まで
     * @name LENGTH_30
     * @constant
     * @memberOf const.MessageConst
     */
    LENGTH_30: '30文字まで',

    /**
     * 半角英数字32文字まで
     * @name HALF_AN_LT_EQ_32
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_LT_EQ_32: '半角英数字32文字まで',

    /**
     * 半角英数字256桁まで
     * @name HALF_AN_LT_EQ_256
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_LT_EQ_256: '半角英数字256桁まで',

    /**
     * 半角英数字８～32文字
     * @name HALF_AN_RANGE_8_32
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_RANGE_8_32: '半角英数字８～32文字',

    /**
     * 半角英数字4桁
     * @name HALF_AN_4
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_4: '半角英数字4桁',

    /**
     * 半角英数字4桁まで
     * @name HALF_AN_LT_EQ_4
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_LT_EQ_4: '半角英数字4桁まで',

    /**
     * 全角1~4桁
     * @name FULL_RANGE_1_4
     * @constant
     * @memberOf const.MessageConst
     */
    FULL_RANGE_1_4: '全角1~4桁',

    /**
     * 半角数字・半角英字(大文字のみ) 1～3桁
     * @name HALF_UPPER_AN_RANGE_1_3
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_UPPER_AN_RANGE_1_3: '半角数字・半角英字(大文字のみ) 1～3桁',

    /**
     * ひらがな・半角英字(大文字のみ) 2桁まで
     * @name HALF_UPPER_A_HIRAGANA_LT_EQ_2
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_UPPER_A_HIRAGANA_LT_EQ_2:
      'ひらがな（お・し・へ・ん・ゐ・ゑ 以外）・半角英字(大文字のみ) 2桁まで',

    /**
     * 半角数字1~4桁
     * @name HALF_AN_RANGE_1_4
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_RANGE_1_4: '半角数字1~4桁',

    /**
     * 半角数字
     * @name HALF
     * @constant
     * @memberOf const.MessageConst
     */
    HALF: '半角数字',

    /**
     * 半角数字16桁まで(「-」は不可)
     * @name HALF_N_LT_EQ_16
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_16: '半角数字16桁まで(「-」は不可)',

    /**
     * 例)[東京 500 ほ 12-34]⇒[1234]
     * @name EXAMPLE_CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    EXAMPLE_CAR_NO: '例)[東京 500 ほ 12-34]⇒[1234]',

    /**
     * 全角カタカナ30文字まで(スペースは不可)
     * @name FULL_KATAKANA_LT_EQ_30
     * @constant
     * @memberOf const.MessageConst
     */
    FULL_KATAKANA_LT_EQ_30: '全角カタカナ30文字まで(スペースは不可)',

    /**
     * 全角4文字
     * @name FULL_4
     * @constant
     * @memberOf const.MessageConst
     */
    FULL_4: '全角4文字',

    /**
     * 半角英数字6文字以上
     * @name HALF_AN_GT_EQ_6
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_GT_EQ_6: '半角英数字6文字以上',

    /**
     * 半角英数字16桁まで
     * @name HALF_AN_LT_EQ_16
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_LT_EQ_16: '半角英数字16桁まで',

    /**
     * 50文字まで
     * @name LT_EQ_50
     * @constant
     * @memberOf const.MessageConst
     */
    LT_EQ_50: '50文字まで',

    /**
     * 255文字まで
     * @name LT_EQ_255
     * @constant
     * @memberOf const.MessageConst
     */
    LT_EQ_255: '255文字まで',

    /**
     * 半角数字4桁まで
     * @name HALF_N_LT_EQ_4
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_4: '半角数字4桁まで',

    /**
     * 半角英数字12桁
     * @name HALF_AN_12
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_AN_12: '半角英数字12桁',

    /**
     * 半角数字・半角英字(大文字のみ)12桁
     * @name HALF_UPPER_AN_12
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_UPPER_AN_12: '半角数字・半角英字(大文字のみ)12桁',

    /**
     * ひらがな50文字まで
     * @name HIRAGANA_GT_EQ_1
     * @constant
     * @memberOf const.MessageConst
     */
    HIRAGANA_GT_EQ_1: 'ひらがな50文字まで',

    /**
     * 全角1桁
     * @name FULL_GT_EQ_1
     * @constant
     * @memberOf const.MessageConst
     */
    FULL_GT_EQ_1: '全角1桁',

    /**
     * 半角数字1~3桁
     * @name HALF_N_RANGE_1_3
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_RANGE_1_3: '半角数字1~3桁',

    /**
     * 重量値
     * @name WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    WEIGHT: '重量値',

    /**
     * 現場コード
     * @name WORKSPACE_CODE
     * @constant
     * @memberOf const.MessageConst
     */
    WORKSPACE_CODE: '現場コード',

    /**
     * 半角数字7桁まで
     * @name HALF_N_LT_EQ_7
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_7: '半角数字7桁まで',

    /**
     * 半角数字5桁まで
     * @name HALF_N_LT_EQ_5
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_5: '半角数字5桁まで',

    /**
     * 半角数字3桁まで
     * @name HALF_N_LT_EQ_3
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_3: '半角数字3桁まで',

    /**
     * 半角数字2桁まで
     * @name HALF_N_LT_EQ_2
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_2: '半角数字2桁まで',

    /**
     * 半角数字12桁まで
     * @name HALF_N_LT_EQ_12
     * @constant
     * @memberOf const.MessageConst
     */
    HALF_N_LT_EQ_12: '半角数字12桁まで',

    /**
     * YYYY/MM/DD
     * @name DATE_YYYY_MM_DD
     * @constant
     * @memberOf const.MessageConst
     */
    DATE_YYYY_MM_DD: 'YYYY/MM/DD',

    /**
     * HH:MM
     * @name TIME_HH_MM
     * @constant
     * @memberOf const.MessageConst
     */
    TIME_HH_MM: 'HH:MM',

    /**
     * 通信に失敗しました。
     * @name MESSAGE_001
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_001: '通信に失敗しました。',

    /**
     * 再度実行してください。
     * @name MESSAGE_002
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_002: '再度実行してください。',

    /**
     * ログインに失敗しました。
     * @name MESSAGE_003
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_003: 'ログインに失敗しました。',

    /**
     * ユーザーIDまたはパスワードが間違っています。
     * @name MESSAGE_004
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_004: 'ユーザーIDまたはパスワードが間違っています。',

    /**
     * 再度実行してください。
     * @name MESSAGE_005
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_005: '再度実行してください。',

    /**
     * 対象の運行履歴データが存在しません。
     * @name MESSAGE_006
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_006: '対象の運行履歴データが存在しません。',

    /**
     * 現在のパスワードが誤っています。
     * @name MESSAGE_007
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_007: '現在のパスワードが誤っています。',

    /**
     * 選択した現場を削除しました。
     * @name MESSAGE_008
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_008: '選択した現場を削除しました。',

    /**
     * 削除に成功しました。
     * @name MESSAGE_009
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_009: '削除に成功しました。',

    /**
     * 登録に成功しました。
     * @name MESSAGE_010
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_010: '登録に成功しました。',

    /**
     * 変更に成功しました。
     * @name MESSAGE_011
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_011: '変更に成功しました。',

    /**
     * 行目
     * @name MESSAGE_012
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_012: '行目',

    /**
     * ファイルのアップロードに失敗しました。
     * @name MESSAGE_013
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_013: 'ファイルのアップロードに失敗しました。',

    /**
     * 入場日の終了は
     * @name MESSAGE_014
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_014: '入場日の終了は',

    /**
     * しますか？
     * @name MESSAGE_015
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_015: 'しますか？',

    /**
     * 終了日は開始日よりも後の日付を選択してください。
     * @name MESSAGE_016
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_016: '終了日は開始日よりも後の日付を選択してください。',

    /**
     * 対象データの取得に失敗しました。再度データを検索してください。
     * @name MESSAGE_017
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_017:
      '対象データの取得に失敗しました。再度データを検索してください。',

    /**
     * 対象データの編集に失敗しました。再度データを検索してください。
     * @name MESSAGE_018
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_018:
      '対象データの編集に失敗しました。再度データを検索してください。',

    /**
     * 入力されたユーザーIDはすでに使用されています。
     * @name MESSAGE_019
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_019: '入力されたユーザーIDはすでに使用されています。',

    /**
     * 設定に失敗しました。しばらくたってから再度実行してください。
     * @name MESSAGE_020
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_020: '設定に失敗しました。しばらくたってから再度実行してください。',

    /**
     * 対象の作業種別データが存在しません
     * @name MESSAGE_021
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_021: '対象の作業種別データが存在しません',

    /**
     * 印刷に成功しました。
     * @name MESSAGE_022
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_022: '印刷に成功しました。',

    /**
     * 選択された車両番号はすでに使用されています。
     * @name MESSAGE_023
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_023: '選択された車両番号はすでに使用されています。',

    /**
     * 選択された車両番号はすでに削除されています。
     * @name MESSAGE_024
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_024: '選択された車両番号はすでに削除されています。',

    /**
     * CSV登録に成功しました。
     * @name MESSAGE_025
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_025: 'CSV登録に成功しました。',

    /**
     * 対象の履歴が存在しないため違反登録できません。
     * @name MESSAGE_026
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_026: '対象の履歴が存在しないため違反登録できません。',

    /**
     * の終了日は開始日以降の日付を選択してください。
     * @name MESSAGE_027
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_027: 'の終了日は開始日以降の日付を選択してください。',

    /**
     * が見つかりません。
     * @name MESSAGE_028
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_028: 'が見つかりません。',

    /**
     * は
     * @name MESSAGE_029
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_029: 'は',

    /**
     * で入力してください。
     * @name MESSAGE_030
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_030: 'で入力してください。',

    /**
     * を入力してください。
     * @name MESSAGE_031
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_031: 'を入力してください。',

    /**
     * が不正です。
     * @name MESSAGE_032
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_032: 'が不正です。',

    /**
     * を選択してください。
     * @name MESSAGE_033
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_033: 'を選択してください。',

    /**
     * を正しく入力してください。
     * @name MESSAGE_034
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_034: 'を正しく入力してください。',

    /**
     * メールアドレスとメールアドレス(確認用)が一致しません。
     * @name MESSAGE_035
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_035: 'メールアドレスとメールアドレス(確認用)が一致しません。',

    /**
     * パスワードとパスワード(確認用)の入力が一致しません。
     * @name MESSAGE_036
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_036: 'パスワードとパスワード(確認用)の入力が一致しません。',

    /**
     * 新しいパスワードと新しいパスワード(確認用)の入力が一致しません。
     * @name MESSAGE_037
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_037:
      '新しいパスワードと新しいパスワード(確認用)の入力が一致しません。',

    /**
     * は半角数字16桁までで入力してください。
     * @name MESSAGE_038
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_038: 'は半角数字16桁までで入力してください。',

    /**
     * ファイルは1つだけ選択してください。
     * @name MESSAGE_039
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_039: 'ファイルは1つだけ選択してください。',

    /**
     * CSVファイルを選択してください。
     * @name MESSAGE_040
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_040: 'CSVファイルを選択してください。',

    /**
     * ファイル名が50文字以内のファイルを選択してください。
     * @name MESSAGE_041
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_041: 'ファイル名が50文字以内のファイルを選択してください。',

    /**
     * ファイルサイズが5MBまでのファイルを選択してください。
     * @name MESSAGE_042
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_042: 'ファイルサイズが5MBまでのファイルを選択してください。',

    /**
     * 削除するデータを選択してください。
     * @name MESSAGE_043
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_043: '削除するデータを選択してください。',

    /**
     * は8桁～32桁で半角数字・半角英字をそれぞれ1文字以上入力してください。
     * @name MESSAGE_044
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_044:
      'は8桁～32桁で半角数字・半角英字をそれぞれ1文字以上入力してください。',

    /**
     * 検索条件を入力してください。
     * @name MESSAGE_045
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_045: '検索条件を入力してください。',

    /**
     * 8文字以上で入力してください。
     * @name MESSAGE_046
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_046: '8文字以上で入力してください。',

    /**
     * 現在のパスワード
     * @name MESSAGE_047
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_047: '現在のパスワード',

    /**
     * 現場名、年月の両方を選択してください。
     * @name MESSAGE_048
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_048: '現場名、年月の両方を選択してください。',

    /**
     * 予定登録を行う月は当月以降を選択してください。
     * @name MESSAGE_049
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_049: '予定登録を行う月は当月以降を選択してください。',

    /**
     * 既に予定がある場合でも上書きされるため注意してください。
     * @name MESSAGE_050
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_050: '既に予定がある場合でも上書きされるため注意してください。',

    /**
     * パスワードを変更しました。次回から新しいパスワードを使用してください。
     * @name MESSAGE_051
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_051:
      'パスワードを変更しました。次回から新しいパスワードを使用してください。',

    /**
     * 該当ページが存在しません。先頭ページを表示します。
     * @name MESSAGE_052
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_052: '該当ページが存在しません。先頭ページを表示します。',

    /**
     * 削除する
     * @name MESSAGE_053
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_053: '削除する',

    /**
     * します。
     * @name MESSAGE_054
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_054: 'します。',

    /**
     * よろしいですか。
     * @name MESSAGE_055
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_055: 'よろしいですか。',

    /**
     * しました。
     * @name MESSAGE_056
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_056: 'しました。',

    /**
     * 退場時刻は入場時刻よりも後の日時を選択してください。
     * @name MESSAGE_057
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_057: '退場時刻は入場時刻よりも後の日時を選択してください。',

    /**
     * 退場日は入場日よりも後の日時を選択してください。
     * @name MESSAGE_058
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_058: '退場日は入場日よりも後の日時を選択してください。',

    /**
     * 予定登録を行う月は当月以降を指定してください。
     * @name MESSAGE_059
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_059: '予定登録を行う月は当月以降を指定してください。',

    /**
     * ユーザIDが不正です。
     * @name MESSAGE_060
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_060: 'ユーザIDが不正です。',

    /**
     * 退場時刻を入力する際は、退場重量を入力してください。
     * @name MESSAGE_061
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_061: '退場時刻を入力する際は、退場重量を入力してください。',

    /**
     * 退場重量を入力する際は、退場時刻を入力してください。
     * @name MESSAGE_062
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_062: '退場重量を入力する際は、退場時刻を入力してください。',

    /**
     * 現在の予定は保存されませんがよろしいですか。
     * @name MESSAGE_063
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_063: '現在の予定は保存されませんがよろしいですか。',

    /**
     * 予定が上書きされますがよろしいですか。
     * @name MESSAGE_064
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_064: '予定が上書きされますがよろしいですか。',

    /**
     * 予定を他の日に反映させますか。
     * @name MESSAGE_065
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_065: '予定を他の日に反映させますか。',

    /**
     * 現場名を選択してください。
     * @name MESSAGE_066
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_066: '現場名を選択してください。',

    /**
     * 予定月を選択してください。
     * @name MESSAGE_067
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_067: '予定月を選択してください。',

    /**
     * 内容を確認して登録してください。
     * @name MESSAGE_068
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_068: '内容を確認して登録してください。',

    /**
     * 予定ありを選択する場合は、台数と回転数を合計台数が1以上となるよう入力してください。
     * @name MESSAGE_069
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_069:
      '予定ありを選択する場合は、台数と回転数を合計台数が1以上となるよう入力してください。',

    /**
     * すべての日付で予定なしが選択されています。
     * @name MESSAGE_070
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_070: 'すべての日付で予定なしが選択されています。',

    /**
     * QRコードの出力に成功しました。
     * @name MESSAGE_071
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_071: 'QRコードの出力に成功しました。',

    /**
     * QRコードの出力に失敗しました。
     * @name MESSAGE_072
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_072: 'QRコードの出力に失敗しました。',
    /**
     * 選択した入荷予定が存在しませんでした。
     * @name MESSAGE_073
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_073: '選択した入荷予定が存在しませんでした。',
    /**
     * 選択した実績が存在しませんでした。
     * @name MESSAGE_074
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_074: '選択した実績が存在しませんでした。',
    /**
     * 選択した入構車両が存在しませんでした。
     * @name MESSAGE_075
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_075: '選択した入構車両が存在しませんでした。',
    /**
     * 選択した車両が存在しませんでした。
     * @name MESSAGE_076
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_076: '選択した車両が存在しませんでした。',
    /**
     * PDFの出力に失敗しました。
     * @name MESSAGE_072
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_077: 'PDFの出力に失敗しました。',

    /**
     * TSVファイルを選択してください。
     * @name MESSAGE_078
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_078: 'TSVファイルを選択してください。',
    /**
     * CSVファイルを選択してください。
     * @name MESSAGE_078
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_079: 'CSVファイルを選択してください。',
    /**
     * 入力できる日数を超過しています。
     * @name MESSAGE_080
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_080: '入力できる日数を超過しています。',

    /**
     * 以内
     * @name MESSAGE_081
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_081: '日以内',

    /**
     * 小数第一位の形式
     * @name MESSAGE_082
     * @constant
     * @memberOf const.MessageConst
     */
    MESSAGE_082: '小数第一位の形式'
  },

  LOGIN: {
    /**
     * LogiPull - ロジプル -
     * @name LOGIPULL
     * @constant
     * @memberOf const.MessageConst
     */
    LOGIPULL: 'LogiPull - ロジプル -',

    /**
     * ログイン
     * @name LOGIN
     * @constant
     * @memberOf const.MessageConst
     */
    LOGIN: 'ログイン',

    /**
     * パスワードを忘れた方は
     * @name FORGET_PW
     * @constant
     * @memberOf const.MessageConst
     */
    FORGET_PW: 'パスワードを忘れた方は',

    /**
     * 新規登録する方は
     * @name REGIST_ACCOUNT
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST_ACCOUNT: '新規登録する方は',

    /**
     * こちら
     * @name HERE
     * @constant
     * @memberOf const.MessageConst
     */
    HERE: 'こちら',

    /**
     * から
     * @name KARA
     * @constant
     * @memberOf const.MessageConst
     */
    KARA: 'から'
  },
  ACCOUNT_EDIT: {
    /**
     * パスワード編集
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: 'パスワード編集',

    /**
     * 現在のパスワード
     * @name CURRENT_PASSWORD
     * @constant
     * @memberOf const.MessageConst
     */
    CURRENT_PASSWORD: '現在のパスワード',

    /**
     * 新しいパスワード
     * @name NEW_PASSWORD
     * @constant
     * @memberOf const.MessageConst
     */
    NEW_PASSWORD: '新しいパスワード',

    /**
     * 新しいパスワード（再確認）
     * @name NEW_PASSWORD_CONFIRM
     * @constant
     * @memberOf const.MessageConst
     */
    NEW_PASSWORD_CONFIRM: '新しいパスワード（再確認）',

    /**
     * キャンセル
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    CANCEL: 'キャンセル',

    /**
     * 変更
     * @name EDIT
     * @constant
     * @memberOf const.MessageConst
     */
    EDIT: '変更'
  },
  CAR_REGIST: {
    /**
     * 車両登録
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '車両登録',

    /**
     * ドライバー氏名
     * @name DRIVER_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    DRIVER_NAME: 'ドライバー氏名',

    /**
     * キャンセル
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    CANCEL: 'キャンセル',

    /**
     * CSV登録登録
     * @name CSV_REGIST
     * @constant
     * @memberOf const.MessageConst
     */
    CSV_REGIST: 'CSV登録',

    /**
     * 登録
     * @name REGIST
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST: '登録'
  },
  CAR_EDIT: {
    /**
     * 車両編集
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '車両編集',

    /**
     * ドライバー氏名
     * @name DRIVER_NAME
     * @constant
     * @memberOf const.MessageConst
     */
    DRIVER_NAME: 'ドライバー氏名',

    /**
     * キャンセル
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    CANCEL: 'キャンセル',

    /**
     * 変更
     * @name EDIT
     * @constant
     * @memberOf const.MessageConst
     */
    EDIT: '変更'
  },
  CAR_CSV_REGIST: {
    /**
     * 車両CSV登録
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '車両CSV登録',
    /**
     * CSVを選択してください。
     * @name SELECT_CSV_MESSAGE
     * @constant
     * @memberOf const.MessageConst
     */
    CSV_REGIST: 'CSVを選択してください。',

    /**
     * CSVを選択してください。
     * @name SELECT_CSV_MESSAGE
     * @constant
     * @memberOf const.MessageConst
     */
    SELECT_CSV_MESSAGE: 'CSVを選択してください。',

    /**
     * 選択されていません
     * @name REGIST_CSV_MESSAGE
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST_CSV_MESSAGE: '選択されていません',

    /**
     * 登録する
     * @name REGIST
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST: '登録する',

    /**
     * 戻る
     * @name BACK
     * @constant
     * @memberOf const.MessageConst
     */
    BACK: '戻る'
  },
  TOTAL_MEASUREMENT: {
    /**
     * 計量記録集計
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '計量記録集計',

    /**
     * 日報
     * @name DAILY_REPORT
     * @constant
     * @memberOf const.MessageConst
     */
    DAILY_REPORT: '日報',

    /**
     * 月報
     * @name MONTHLY_REPORT
     * @constant
     * @memberOf const.MessageConst
     */
    MONTHLY_REPORT: '月報',

    /**
     * CSV出力
     * @name OUTPUT_CSV
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_CSV: 'CSV出力',

    /**
     * 時間
     * @name TIME
     * @constant
     * @memberOf const.MessageConst
     */
    TIME: '時間',

    /**
     * 車番
     * @name CARNO
     * @constant
     * @memberOf const.MessageConst
     */
    CARNO: '車番',

    /**
     * 総量
     * @name TOTAL_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    TOTAL_WEIGHT: '総量',

    /**
     * 空量
     * @name EMPTY_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    EMPTY_WEIGHT: '空量',

    /**
     * 正味
     * @name NET_WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    NET_WEIGHT: '正味',

    /**
     * NO
     * @name NO
     * @constant
     * @memberOf const.MessageConst
     */
    NO: 'NO'
  },
  PACKAGE_LIST: {
    /**
     * 入荷一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '入荷一覧',
    /**
     * NO
     * @name NO
     * @constant
     * @memberOf const.MessageConst
     */
    NO: ' ',
    /**
     * 日付
     * @name DATE
     * @constant
     * @memberOf const.MessageConst
     */
    DATE: '日付',
    /**
     * 車両番号
     * @name CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO: '車両番号',
    /**
     * 荷姿
     * @name PACKAGE
     * @constant
     * @memberOf const.MessageConst
     */
    PACKAGE: '荷姿',
    /**
     * 数量
     * @name VOLUME
     * @constant
     * @memberOf const.MessageConst
     */
    VOLUME: '数量',
    /**
     * 単位
     * @name UNIT
     * @constant
     * @memberOf const.MessageConst
     */
    UNIT: '単位',
    /**
     * 重量
     * @name WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    WEIGHT: '重量',
    /**
     * (kg)
     * @name KG
     * @constant
     * @memberOf const.MessageConst
     */
    KG: '（kg）',
    /**
     * 受入場所
     * @name RECEIVE_PLACE
     * @constant
     * @memberOf const.MessageConst
     */
    RECEIVE_PLACE: '受入場所',

    /**
     * 受入場所
     * @name RECEIVE_PLACE
     * @constant
     * @memberOf const.MessageConst
     */
    RECEIVE_TO: '受入先',

    /**
     * 受入判定特記事項
     * @name SPECIAL_NOTE
     * @constant
     * @memberOf const.MessageConst
     */
    SPECIAL_NOTE: '受入判定特記事項',
    /**
     * ステータス
     * @name STATUS
     * @constant
     * @memberOf const.MessageConst
     */
    STATUS: 'ステータス',
    /**
     * 編集
     * @name EDIT
     * @constant
     * @memberOf const.MessageConst
     */
    EDIT: '編集',
    /**
     * 変更
     * @name CHANGE
     * @constant
     * @memberOf const.MessageConst
     */
    CHANGE: '変更',
    /**
     * キャンセル
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    CANCEL: 'キャンセル',
    /**
     * CSV登録
     * @name CANCEL
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST_CSV: 'TSV登録',
    /**
     * 絞り込み検索
     * @name REFINED_SEARCH
     * @constant
     * @memberOf const.MessageConst
     */
    REFINED_SEARCH: '絞り込み検索'
  },
  PACKAGE_EDIT: {
    /**
     * 入荷編集
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '入荷編集'
  },
  PACKAGE_CSV: {
    /**
     * 受注コードTSV登録
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '受注コードTSV登録',
    /**
     * 登録
     * @name REGIST
     * @constant
     * @memberOf const.MessageConst
     */
    REGIST: '登録'
  },
  TICKET_LIST: {
    /**
     * 発券一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '発券一覧'
  },
  CAR_LIST: {
    /**
     * 車両一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '車両一覧',
    /**
     * 日付
     * @name DATE
     * @constant
     * @memberOf const.MessageConst
     */
    DATE: '日付',
    /**
     * 車両番号
     * @name CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO: '車両番号',
    /**
     * 重量（kg）
     * @name WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    WEIGHT: '重量（kg）',
    /**
     * 行先
     * @name TO
     * @constant
     * @memberOf const.MessageConst
     */
    TO: '行先',
    /**
     * 備考
     * @name NOTE
     * @constant
     * @memberOf const.MessageConst
     */
    NOTE: '備考',
    /**
     * QR印刷
     * @name QR
     * @constant
     * @memberOf const.MessageConst
     */
    QR: 'QR印刷',
    /**
     * (4ケタ番号)
     * @name PLATE_NUMBER
     * @constant
     * @memberOf const.MessageConst
     */
    PLATE_NUMBER: '(4ケタ番号)'
  },
  ENTRYCAR_LIST: {
    /**
     * 入構車両一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '入構車両一覧',
    /**
     * 日付
     * @name DATE
     * @constant
     * @memberOf const.MessageConst
     */
    DATE: '日付',
    /**
     * 車両番号
     * @name CAR_NO
     * @constant
     * @memberOf const.MessageConst
     */
    CAR_NO: '車両番号',
    /**
     * 重量（kg）
     * @name WEIGHT
     * @constant
     * @memberOf const.MessageConst
     */
    WEIGHT: '重量（kg）',
    /**
     * 行先
     * @name TO
     * @constant
     * @memberOf const.MessageConst
     */
    TO: '行先',
    /**
     * 備考
     * @name NOTE
     * @constant
     * @memberOf const.MessageConst
     */
    NOTE: '備考'
  },
  RESULT_CSV_LIST: {
    /**
     * 実績一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '実績CSV一覧'
  },
  RESULT_LIST: {
    /**
     * マニュフェスト交付日
     * @name DATE_OF_ISSUE
     * @constant
     * @memberOf const.MessageConst
     */
    DATE_OF_ISSUE: 'マニュフェスト交付日',
    /**
     * マニュフェスト交付担当
     * @name STAFF_OF_ISSUE
     * @constant
     * @memberOf const.MessageConst
     */
    STAFF_OF_ISSUE: 'マニュフェスト交付担当',
    /**
     * 実績一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '実績一覧',
    /**
     * 実績数量
     * @name RESULT_VOLUME
     * @constant
     * @memberOf const.MessageConst
     */
    RESULT_VOLUME: '実績数量',
    /**
     * 荷卸し場
     * @name PACKAGE_DROP_PLACE
     * @constant
     * @memberOf const.MessageConst
     */
    PACKAGE_DROP_PLACE: '荷卸し場',
    /**
     * 受注コード
     * @name ORDER_CODE
     * @constant
     * @memberOf const.MessageConst
     */
    ORDER_CODE: '受注コード',
    /**
     * 明細番号
     * @name SERIAL_NUM
     * @constant
     * @memberOf const.MessageConst
     */
    SERIAL_NUM: '明細番号',
    /**
     * CSV出力
     * @name OUTPUT_CSV
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_CSV: 'CSV出力',
    /**
     * 工場側CSV出力
     * @name OUTPUT_FACTORY_CSV
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_FACTORY_CSV: '工場側CSV出力',
    /**
     * 物流側CSV出力
     * @name OUTPUT_LOGISTICS_CSV
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_LOGISTICS_CSV: '物流側CSV出力',
    /**
     * 備考
     * @name NOTE
     * @constant
     * @memberOf const.MessageConst
     */
    NOTE: '備考',
    /**
     * 備考
     * @name IS_EDIT
     * @constant
     * @memberOf const.MessageConst
     */
    IS_EDIT: '編集済判定'
  },
  RESULT_EDIT: {
    /**
     * 実績編集
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '実績編集'
  },
  RESULT_CSV_EDIT: {
    /**
     * 実績CSV編集
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '実績CSV編集'
  },
  MEASURE_LIST: {
    /**
     * 計量データ配信一覧
     * @name TITLE
     * @constant
     * @memberOf const.MessageConst
     */
    TITLE: '計量データ配信一覧',
    /**
     * PDF
     * @name OUTPUT_CSV
     * @constant
     * @memberOf const.MessageConst
     */
    OUTPUT_PDF: 'PDF',
    /**
     * 入場日
     * @name ENTRY_DATE
     * @constant
     * @memberOf const.MessageConst
     */
    ENTRY_DATE: '入場日'
  },
  RESULT_CODE: {
    /**
     * アンテナが存在しません。
     * @name 101
     * @constant
     * @memberOf const.MessageConst
     */
    101: 'アンテナが存在しません。',

    /**
     * エリアが存在しません。
     * @name 102
     * @constant
     * @memberOf const.MessageConst
     */
    102: 'エリアが存在しません。',

    /**
     * 車両が存在しません。
     * @name 103
     * @constant
     * @memberOf const.MessageConst
     */
    103: '車両が存在しません。',

    /**
     * Fa-2が存在しません。
     * @name 104
     * @constant
     * @memberOf const.MessageConst
     */
    104: 'Fa-2が存在しません。',

    /**
     * ゲートが存在しません。
     * @name 105
     * @constant
     * @memberOf const.MessageConst
     */
    105: 'ゲートが存在しません。',

    /**
     * 滞在状態が存在しません。
     * @name 106
     * @constant
     * @memberOf const.MessageConst
     */
    106: '滞在状態が存在しません。',

    /**
     * トラックスケールが存在しません。
     * @name 107
     * @constant
     * @memberOf const.MessageConst
     */
    107: 'トラックスケールが存在しません。',

    /**
     * 現場が存在しません。
     * @name 108
     * @constant
     * @memberOf const.MessageConst
     */
    108: '現場が存在しません。',

    /**
     * 作業種別が存在しません。
     * @name 109
     * @constant
     * @memberOf const.MessageConst
     */
    109: '作業種別が存在しません。',

    /**
     * 運行履歴が存在しません。
     * @name 111
     * @constant
     * @memberOf const.MessageConst
     */
    111: '運行履歴が存在しません。',

    /**
     * トラックスケールの状況が存在しません。
     * @name 112
     * @constant
     * @memberOf const.MessageConst
     */
    112: 'トラックスケールの状況が存在しません。',

    /**
     * 現場予定が存在しません。
     * @name 113
     * @constant
     * @memberOf const.MessageConst
     */
    113: '現場予定が存在しません。',

    /**
     * 同一のWCNが既に登録されています。
     * @name 114
     * @constant
     * @memberOf const.MessageConst
     */
    114: '同一のWCNが既に登録されています。',

    /**
     * 同一の車両番号が既に登録されています。
     * @name 115
     * @constant
     * @memberOf const.MessageConst
     */
    115: '同一の車両番号が既に登録されています。',

    /**
     * 運行履歴は既に退場となっています。
     * @name 116
     * @constant
     * @memberOf const.MessageConst
     */
    116: '運行履歴は既に退場となっています。',

    /**
     * アカウントが存在しません。
     * @name 117
     * @constant
     * @memberOf const.MessageConst
     */
    117: 'アカウントが存在しません。',

    /**
     * 現在のパスワードが誤っています。
     * @name 119
     * @constant
     * @memberOf const.MessageConst
     */
    119: '現在のパスワードが誤っています。',

    /**
     * アカウントの更新権限がありません。
     * @name 120
     * @constant
     * @memberOf const.MessageConst
     */
    120: 'アカウントの更新権限がありません。',

    /**
     * 同一の現場コードが既に登録されています。
     * @name 121
     * @constant
     * @memberOf const.MessageConst
     */
    121: '同一の現場コードが既に登録されています。',

    /**
     * 呼出可能なステータスではありません。
     * @name 122
     * @constant
     * @memberOf const.MessageConst
     */
    122: '呼出可能なステータスではありません。',

    /**
     * 検量書の印刷・ダウンロードができません。
     * @name 123
     * @constant
     * @memberOf const.MessageConst
     */
    123: '検量書の印刷・ダウンロードができません。',

    /**
     * 検量書作成処理中にエラーが発生いたしました。管理者へお問い合わせ下さい。
     * @name 124
     * @constant
     * @memberOf const.MessageConst
     */
    124: '検量書作成処理中にエラーが発生いたしました。管理者へお問い合わせ下さい。',

    /**
     * ステータスと入力状態が適切ではありません。
     * @name 125
     * @constant
     * @memberOf const.MessageConst
     */
    125: 'ステータスと入力状態が適切ではありません。',

    /**
     * 削除できない現場が選択されました。
     * @name 126
     * @constant
     * @memberOf const.MessageConst
     */
    126: '削除できない現場が選択されました。',

    /**
     * 同一の電話番号が既に登録されています。
     * @name 127
     * @constant
     * @memberOf const.MessageConst
     */
    127: '同一の電話番号が既に登録されています。'
  }
};

export default MessageConst;



// WEBPACK FOOTER //
// ./src/js/const/MessageConst.jsx